<template>
  <div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>票据总览</span>
      </div>

      <el-form
        label-width="85px"
        label-position="left"
        style="padding:20px 20px 0 30px;margin-bottom:0 !important;"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item
              style="margin-bottom:12px !important;"
              label="已收票金额："
            >{{ params.receiveMoney|priceFilterNum }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              style="margin-bottom:12px !important;"
              label="待收票金额："
            >{{ params.noreceiveMoney|priceFilterNum }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="padding-left:30px;">
        <i style="margin-top:1px;" class="el-icon-warning-outline"></i>
        <span style="font-size:12px;">说明：退票或红字退票产品均归为待收票产品;</span>
      </div>
    </div>
    <div class="item-box-content">
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>收票记录</span>
          </div>
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <el-button @click="onApplyForTicketCollection" :disabled="!params.state" type="primary" plain>收取普通发票</el-button>
        </el-col>
      </el-row>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="params.purchaseContractInvocieVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        max-height="378"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="way" label="收票编号" width="120px">
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onTicketCollectionDetails(scope.row)"
            >{{ scope.row.invoiceReceiveNumber }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceReceiveCompany" label="公司名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="invoiceNumber" label="发票编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="amount" label="发票金额">
          <template slot-scope="scope">{{ scope.row.amount|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column prop="taxAmount" label="税额">
          <template slot-scope="scope">{{ scope.row.taxAmount|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column width="150px" prop="applicationDate" label="申请时间">
          <template slot-scope="scope">
            <div>{{ scope.row.applicationDate | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceType" label="发票类型"></el-table-column>
        <el-table-column prop="bilingType" label="收票类型"></el-table-column>
        <el-table-column prop="invoiceState" label="发票状态">
          <template slot-scope="scope">
            <div>{{ scope.row.invoiceState | inState}}</div>
          </template>
        </el-table-column>
        <el-table-column width="150px" prop="invoiceReceiveDate" label="收票时间">
          <template slot-scope="scope">
            <div>{{ scope.row.invoiceReceiveDate | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="handler" label="处理人"></el-table-column>
      </el-table>
    </div>
    <div class="item-box-content">
      <el-row>
        <el-col :span="18">
          <el-col :span="24">
            <div class="title-font-style line-limit-length">
              <span>退票记录</span>
            </div>
          </el-col>
        </el-col>
        <el-col :span="6" style="text-align:right;">
          <el-button @click="onApplyForRefund" type="primary" :disabled="!params.subState" plain>申请退票</el-button>
          <el-button @click="onApplyForRedRefund" type="primary" :disabled="!params.subHotState" plain>申请红字信息表</el-button>
        </el-col>
      </el-row>
      <el-row style="padding:7px 7px 0 7px;">
        <el-col :span="18">
          <i style="padding-left:20px;padding-top:1px;" class="el-icon-warning-outline"></i>
          <span class="title-font-style-explain">
            仅允许对未核销发票进行退票申请，退票审核通过后请交至财务部领取发票；已核销发票需申请
            <span
              style="color:#C11A1A;font-size:14px;"
            >红字信息表</span>后，由对方公司开具红字发票
          </span>
        </el-col>
      </el-row>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="params.purchaseContractInvoiceSubListVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        max-height="378"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="退票编号" width="120px">
          <template slot-scope="scope">
            <div class="approval" @click="onRefundDetails(scope.row)">{{ scope.row.subNumber }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="company" label="公司名称"></el-table-column>
        <el-table-column prop="invoiceNumber" label="发票编号"></el-table-column>
        <el-table-column prop="amount" label="发票金额">
          <template slot-scope="scope">{{ scope.row.amount|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column prop="taxAmount" label="税额">
          <template slot-scope="scope">{{ scope.row.taxAmount|priceFilterNum }}</template>
        </el-table-column>
        <el-table-column width="150px" prop="createDate" label="申请时间">
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="subType" label="发票类型">
          <template slot-scope="scope">
            <div>{{ scope.row.subType === 1 ? "红字发票" : "普通发票" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="退票状态">
          <template slot-scope="scope">
            <div>{{ switchState(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column width="150px" prop="processDate" label="退票时间">
          <template slot-scope="scope">
            <div>{{ scope.row.processDate | dateFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="processUser" label="处理人"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { queryAllInvocie } from '@/api/purchase/purchasePlanList'
export default {
  data () {
    return {
      status: ['未提交', '审核中', '已通过', '已拒绝', '已退票', '拒绝退票', '待收票'], // 退票状态
      giveStatus: ['未收票', '已收票', '已退票'], // 发票状态
      params: {}, // 数据
      loadingTable: false,
      ticketCollectionRecordList: [{ code: 'KP-190301-0001' }],
      refundRecordList: [
        { code: 'KP-190301-0001', type: '普通发票' },
        { code: 'KP-190301-0001', type: '红字发票' }
      ]
    }
  },
  filters: {
    inState: (value) => {
      switch (value) {
        case 1:
          return '收票审核'
        case 2:
          return '已收票'
        case 3:
          return '已收票'
        case 4:
          return '审核不通过'
        case 5:
          return '退票中'
      }
    }
  },

  methods: {
    switchState(row) {
      const {
        subType,
        state
      } = row
      if (subType !== 1) {
        switch (state) {
          case 3:
          case 5:
            return '审核不通过'
          case 4:
            return '已退票'
          default:
            return '退票审核'
        }
      } else {
        return this.inState1(state)
      }
    },
    inState1: (value) => {
      switch (value) {
        case 0:
        case 1:
          return '申请审核'
        case 6:
          return '待收票'
        case 4:
          return '已收票'
        case 3:
        case 5:
          return '审核不通过'
        default:
          return '开具红字信息表'
      }
    },
    getList () {
      queryAllInvocie(this.$route.query.pcbId)
        .then((res) => {
          if (res.data.code === 200) {
            this.params = res.data.obj.purchaseContractInvocieListVo
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onInitial () {
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 申请普通发票
    onApplyForTicketCollection () {
      this.$router.push({
        name: 'applyForTicketCollection',
        query: {
          pcbId: this.$route.query.pcbId,
          type: this.$route.query.type
        }
      })
    },
    // 普通收票详情
    onTicketCollectionDetails (row) {
      this.$router.push({
        name: 'ticketCollectionDetails',
        query: { invoiceReceiveNumber: row.invoiceReceiveNumber }
      })
    },
    // 申请退票
    onApplyForRefund () {
      this.$router.push({
        name: 'redApplyForRefund',
        query: {
          sendType: this.$route.query.type,
          pcbId: this.$route.query.pcbId,
          typeex: 1
        }
      })
    },
    // 申请红字退票
    onApplyForRedRefund () {
      this.$router.push({
        name: 'redApplyForRefund',
        query: {
          type: 'red',
          typeex: 2,
          sendType: this.$route.query.type,
          pcbId: this.$route.query.pcbId
        }
      })
    },
    // 红字,普通发票详情
    onRefundDetails (row) {
      this.$router.push({
        name: 'refundDetails',
        query: { pcisId: row.pcisId }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title-font-style-explain {
  // padding-left: 20px;
  font-size: 12px;
  // padding-left: 20px;
  font-weight: 400;
  color: rgba(78, 85, 91, 1);
}
</style>
